
import React, { PropTypes } from 'react';

const Spacer = ({ ix }) => (
  ix > 0 ? <span>{' '}|{' '}</span> : null
);


Spacer.propTypes = {
  ix: PropTypes.number.isRequired
};

export default Spacer;



// WEBPACK FOOTER //
// ./src/components/projects/descriptions/Spacer.js